/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_SpanishInputs */



/**
* | output |
* | --- |
* | "Spanish" |
*
* @param {Speechmatics_Target_Language_SpanishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_spanish = /** @type {((inputs?: Speechmatics_Target_Language_SpanishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_SpanishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Espagnol")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spanisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("spagnolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("испанский")
	if (locale === "es") return /** @type {LocalizedString} */ ("Español")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("西班牙语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スペイン語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पैनिश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espanhol")
	return /** @type {LocalizedString} */ ("Spanish")
});